// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUser } from '@ni/nimble-components/dist/esm/icons/user';
import { wrap } from '../utilities/react-wrapper';

export { type IconUser };
export const NimbleIconUser = wrap(IconUser);